export const scenarioQueryKeys = {
    pageAll: () => ['page-scenarios'] as const,
    detail: (id: string) => ['scenario', id] as const,
    recent: () => ['scenarios', 'recent'] as const,
    autocompletes: (id: string) => ['scenario', "autocompletes", id] as const
} as const;
